import React from 'react';
import Head from 'next/head';
import MarketingNavigation from '../../../navigation/marketing';
import BlogsIndex from '../../../components/ArticleBlocks/BlogsIndex';
import HeroAngledImageOnRight from '../../../components/ArticleBlocks/HeroAngledImageOnRight';
import PageFooter from '../../../components/ArticleBlocks/PageFooter';

export default function News() {

  return (
    <>
      <Head>
        <title>Kingdom Advisors Blog</title>
        <meta name="description" content="Kingdom Advisors Blog allows you to stay in touch with our latest tips on biblically wise financial counsel and more." />
      </Head>
      <MarketingNavigation>
        <div>
          <div>
            <HeroAngledImageOnRight
              blockInfo={{
                backgroundColor: "#213B72",
                textColor: "#ffffff",
                preheadline: "",
                headline: "Industry News",
                subhead: "Learn about the latest trends and highlights inside the Christian financial industry.",
                button1: null,
                button2: null,
                postButtonText: "",
                headerImage: {
                  url: "https://kawebresources.s3.amazonaws.com/siteimages/headerbackgrounds/_1000x667_crop_center-center_none/AdobeStock_328523611.jpeg?v=1747771465",
                  title: "Industry News"
                }
              }}
            />
          </div>
          <div className='mt-4'>
            <BlogsIndex />
          </div>
          <PageFooter />
        </div>
      </MarketingNavigation>
    </>
  )
}

News.getLayout = page => <>{page}</>;
News.isPublic = true;
